import { render, staticRenderFns } from "./GameItemsEdit.vue?vue&type=template&id=c191a2ac&"
import script from "./GameItemsEdit.vue?vue&type=script&lang=js&"
export * from "./GameItemsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GameItemsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports